import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Select from 'react-select';
import { SlArrowLeft } from "react-icons/sl";
import { BASE_URL } from '../../insightConfig/insightConfig';
import { Modal } from 'react-bootstrap';


const UGC_Dashboard = () => {
    const location = useLocation();
    const [orders, setOrders] = useState([]);
    const [selectedOrders, setSelectedOrders] = useState([]);
    const [selecteSection, setSelectedSection] = useState(location?.state?.selecteSection || 'All Sections');
    const [selectedOrder, setSelectedOrder] = useState({});
    // let attempedTests = selectedOrder.CompletedTests + 1;
    const [tests, setTests] = useState([]);
    const [savedSubjectId, setSavedSubjectId] = useState(null);
    const [allSubjects, setAllSubjects] = useState([]);
    const [showPreferenceModal, setShowPreferenceModal] = useState(false);
    const [selectedPreference, setSelectedPreference] = useState({ Sn: 0, Subject: 'Please select subject' });
    const { Sn, OrderID, ExamType, Duration, Marks_per_Question, Negative_Marking, QuestionCount, Subject, SubjectID, TestCount, CompletedTests, QuestionsToBeAttempted, Attempt } = selectedOrder;
    useEffect(() => {
        const fetchData = async () => {
            const response = await axios.get(BASE_URL + "/ugc/user/my-tests-orders");
            const allOrders = response?.data?.data || [];
            setOrders(allOrders);
            const initialSection = location?.state?.selecteSection;
            if (initialSection && initialSection !== 'All Sections') {
                setSelectedOrders(allOrders.filter((data) => data.ExamType === initialSection));
            } else {
                setSelectedOrders(allOrders);
            }
        }
        const fetchPreference = async () => {
            try {
                const authToken = localStorage.getItem("authtoken");
                if (!authToken) return;
                
                const prefRes = await axios.get(BASE_URL + "/ugc/user/preference", { headers: { 'authtoken': authToken } });
                const subId = prefRes?.data?.data?.subjectId;
                if (subId) {
                    setSavedSubjectId(subId);
                } else {
                    // Show modal if not saved
                    setShowPreferenceModal(true);
                }

                const subRes = await axios.get(BASE_URL + "/ugc/user/subjects/SUBJECT SPECIFIC");
                setAllSubjects(subRes?.data?.data || []);
            } catch (e) {
                console.error(e);
            }
        }
        fetchData()
        fetchPreference()
    }, [])

    const handleSavePreference = async () => {
        if (!selectedPreference.Sn) {
            alert("Please select a subject.");
            return;
        }
        try {
            const authToken = localStorage.getItem("authtoken");
            await axios.post(BASE_URL + "/ugc/user/preference", { subjectId: selectedPreference.Sn }, { headers: { 'authtoken': authToken } });
            setSavedSubjectId(selectedPreference.Sn);
            setShowPreferenceModal(false);
        } catch (e) {
            console.error(e);
            alert("Error saving preference.");
        }
    }

    useEffect(() => {
        if (Sn) {
            setTests(Array.from({ length: TestCount }, (_, i) => i + 1));
        }
    }, [Sn])
    return (
        <>
            {
                !Sn ?
                    <div className="container-fluid px-2">
                        <div className="card shadow-sm">
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="w-25 bg-light">
                                    <Select
                                        id='select_test'
                                        value={{ value: selecteSection, label: selecteSection }}
                                        onChange={(selectedOption) => {
                                            setSelectedSection(selectedOption.value);
                                            if (selectedOption.value == 'All Sections') {
                                                setSelectedOrders(orders);
                                                return
                                            }
                                            setSelectedOrders(orders.filter((data) => data.ExamType == selectedOption.value));

                                        }
                                        }
                                        options={['All Sections', 'GENERAL APTITUDE', 'SUBJECT SPECIFIC', 'COMBINED']?.map((item) => ({ value: item, label: item }))}
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '100%',
                                                backgroundColor: 'white',
                                                borderColor: '#17a2b8'
                                            })
                                        }}
                                    />
                                </div>
                                <div className="w-25 d-flex justify-content-end">
                                    <Link to={'/ugc-net'} className='btn btn-info text-light mt-1 me-1 fw-semibold' >Purchase Tests</Link>
                                </div>
                            </div>


                            <div className="card-body mt-0 pt-2">
                                <div className="table-responsive">
                                    <table className="table table-bordered text-center">
                                        <thead>
                                            <tr>
                                                <th colSpan="6" style={{ backgroundColor: "#ff2f00" }} className="text-white fs-6">UGG-NET ENROLLED PROGRAMS</th>
                                            </tr>
                                            <tr className="bg-light">
                                                <th>S No.</th>
                                                <th>Section</th>
                                                <th>Subject</th>
                                                <th>No. of Tests</th>
                                                <th>Date of Enrollment</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedOrders?.map((course, index) => (
                                                <tr key={index} className='p-0'>
                                                    <td>{index + 1}</td>
                                                    <td>{course.ExamType}</td>
                                                    <td>{course.Subject || 'Aptitude Test'}</td>
                                                    <td>{course.TestCount}</td>
                                                    <td>
                                                        {(() => {
                                                            const d = new Date(course.PaymentDate);
                                                            d.setHours(d.getHours() - 6.5); // subtract 6 hours
                                                            return d.toLocaleDateString('en-GB');
                                                        })()}
                                                    </td>

                                                    <td><button className='btn btn-success btn-sm px-3' onClick={() => setSelectedOrder(course)}> Start</button> </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div> :
                    <div className='card p-2 pt-1 my-4 mx-2 shadow-lg'>
                        <div className="d-flex justify-content-between align-items-center p-2 py-1 bg-light border rounded shadow-sm">
                            <button
                                className="btn btn-sm"
                                style={{
                                    backgroundColor: '#17a2b8',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '5px',
                                    padding: '4px 12px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                    cursor: 'pointer'
                                }}
                                onClick={() => setSelectedOrder({})}
                            >
                                <SlArrowLeft /> Back
                            </button>
                            <h2 className="mb-0 fs-5" style={{ color: 'rgb(183, 6, 6)', fontWeight: 600, letterSpacing: '0.5px', textShadow: '0 1px 1px rgba(0,0,0,0.1)', lineHeight: '1.2' }}>{Subject || ExamType}</h2>
                            <span style={{ backgroundColor: "#6e1158" }} className="badge  text-white fs-6">Tests: {TestCount}</span>
                        </div>
                        {tests?.map((testData, index) => {
                            const testNumber = index + 1;
                            console.log(CompletedTests?.split(','));
                            let isAttempted = false;
                            let attemptCount = 0;
                            if (CompletedTests != '') {
                                isAttempted = testNumber <= CompletedTests?.split(',').length;
                                attemptCount = CompletedTests?.split(',')[testNumber - 1] || 0;
                            }

                            return (
                                < div key={index} className="d-grid gap-1 m-1 test-togglebackground" >
                                    <button className="toggle-button py-1">
                                        <div className="text-nowrap me-2 fw-medium">
                                            Test-{index + 1}
                                        </div>
                                        <div className='toggleheadingContainer me-3'></div>
                                        <div className='toggleheadingContainer me-3'></div>
                                        <div className="d-flex justify-content-end align-items-center gap-1 w-75">
                                            {
                                                Number(attemptCount) < Attempt && isAttempted &&
                                                < Link to={`/ugc-net/online-exam/instructions`} state={{ testDetails: { ...selectedOrder, SubjectID: SubjectID || savedSubjectId, exam_type: ExamType, testNumber: index + 1, orderId: OrderID, Duration: Duration, marksPerQuestion: Marks_per_Question, negativeMarking: Negative_Marking, questionLimit: QuestionCount, questionsToBeAttempted: QuestionsToBeAttempted, reAttempt: true } }} className='list-group-item p-1 fw-bold bg-pureorange test-btn text-white w-50'>
                                                    REATTEMPT
                                                </Link >
                                            }
                                            < Link to={`/ugc-net/online-exam/${isAttempted ? 'report' : 'instructions'}`} state={{ testDetails: { ...selectedOrder, SubjectID: SubjectID || savedSubjectId, exam_type: ExamType, testNumber: index + 1, orderId: OrderID, Duration: Duration, marksPerQuestion: Marks_per_Question, negativeMarking: Negative_Marking, questionLimit: QuestionCount, questionsToBeAttempted: QuestionsToBeAttempted } }} className='list-group-item p-1 fw-bold bg-pureorange test-btn text-white w-50'>
                                                {isAttempted ? "REPORT" : "START"}
                                            </Link >
                                        </div>


                                    </button>
                                </div>
                            )
                        }

                        )}
                    </div >
            }

            <Modal show={showPreferenceModal} centered backdrop="static" keyboard={false}>
                <div className="modal-content p-4" style={{ backgroundColor: "#f0f8ff", borderRadius: "10px" }}>
                    <h4 className="text-center text-info mb-4">Set Your Domain Subject</h4>
                    <p className="text-center mb-3">Please select your Domain / Academic Subject for UGC-NET. This will be saved in your dashboard for future tests.</p>
                    <Select
                        id='preference_select'
                        value={{ value: selectedPreference, label: selectedPreference?.Subject }}
                        onChange={(selectedOption) => setSelectedPreference(selectedOption.value)}
                        options={allSubjects?.map((item) => ({ value: item, label: item?.Subject }))}
                        styles={{
                            control: (provided) => ({
                                ...provided,
                                width: '100%',
                                backgroundColor: 'white',
                                borderColor: '#17a2b8'
                            })
                        }}
                    />
                    <div className="mt-4 d-flex justify-content-center">
                        <button className="btn btn-success" onClick={handleSavePreference}>Save Preference</button>
                    </div>
                </div>
            </Modal>
        </>


    )
}

export default UGC_Dashboard